const OrganizationRequiringSubscriptionCollectionFields = [
];

export default OrganizationRequiringSubscriptionCollectionFields;